import React from 'react';
import { MdClose } from 'react-icons/md';

export default function EssayAiSelection({ candidates, onRemove, onClear }) {
  if (!candidates.length) return null;
  return <section className="essay-ai-selection hidethis" aria-label="Candidatos selecionados">
    <div className="essay-ai-selection-heading"><strong>{candidates.length} candidato(s) selecionado(s)</strong>{onClear && <button type="button" className="btn btn-outline-danger btn-sm" onClick={onClear}>Limpar seleção</button>}</div>
    <div className="essay-ai-selection-list">{candidates.map(candidate => <span className="essay-ai-selection-chip" key={candidate.id} title={candidate.name}>
      <span>{candidate.registration || `Sem inscrição · ${candidate.name}`}</span>
      {onRemove && <button type="button" aria-label={`Remover inscrição ${candidate.registration || candidate.name} da seleção`} onClick={() => onRemove(candidate.id)}><MdClose /></button>}
    </span>)}</div>
  </section>;
}
